var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSearch = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H16V16H0z",
    transform: "translate(-18 -9) translate(18 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.837 10.377L9.5 8.04a.562.562 0 0 0-.4-.164h-.381a4.873 4.873 0 1 0-.844.844v.38a.562.562 0 0 0 .164.4l2.337 2.337a.56.56 0 0 0 .795 0l.663-.663a.565.565 0 0 0 .003-.797zm-6.961-2.5a3 3 0 1 1 3-3 3 3 0 0 1-3.001 2.999z",
    transform: "translate(-18 -9) translate(20 11)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-search.72b4d09b.svg";
export { ForwardRef as ReactComponent };